import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { ProfileStatus, UserListItem } from "../types/admin";

export const userService = {
  async listUsers(search = "", limit = 100): Promise<UserListItem[]> {
    assertSupabaseConfigured();

    const { data, error } = await supabase.rpc("admin_list_users", {
      p_search: search,
      p_limit: limit,
    });

    if (error) {
      throw error;
    }

    return (data ?? []) as UserListItem[];
  },

  async updateUserStatus(userId: string, status: ProfileStatus) {
    assertSupabaseConfigured();

    const { error } = await supabase.rpc("admin_update_profile_status", {
      p_user_id: userId,
      p_status: status,
    });

    if (error) {
      throw error;
    }
  },

  async deleteTestUser(userId: string, confirmEmail: string) {
    assertSupabaseConfigured();

    const { error } = await supabase.rpc("admin_delete_test_user", {
      p_user_id: userId,
      p_confirm_email: confirmEmail,
    });

    if (error) {
      throw error;
    }
  },
};
